import {
    DeviceDetailsState,
    DevicesFetchStartAction,
    DevicesFetchSuccessAction,
    DevicesFetchErrorAction,
    DevicesChannelsFetchStartAction,
    DevicesChannelsFetchSuccessAction,
    DevicesChannelsFetchErrorAction,
} from './types';
import { DeviceDetailsActionTypes } from './types';
import { DevicesParams, DevicesChannelParams } from '@api/services/ElasticApi';
import { ApplicationState } from '..';

export const DevicesFetchStart = (params: DevicesParams): DevicesFetchStartAction => {
    return {
        type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS,
        payload: params,
    };
};
export const DevicesFetchSuccess = (params: DeviceDetailsState): DevicesFetchSuccessAction => {
    return {
        type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_SUCCESS,
        payload: params,
    };
};
export const DevicesFetchError = (): DevicesFetchErrorAction => {
    return {
        type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_ERROR,
    };
};

export const DevicesChannelsFetchStart = (params: DevicesChannelParams): DevicesChannelsFetchStartAction => {
    return {
        type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS,
        payload: params,
    };
};
export const DevicesChannelsFetchSuccess = (params: DeviceDetailsState): DevicesChannelsFetchSuccessAction => {
    return {
        type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS_SUCCESS,
        payload: params,
    };
};
export const DevicesChannelsFetchError = (): DevicesChannelsFetchErrorAction => {
    return {
        type: DeviceDetailsActionTypes.GET_DEVICE_DETAILS_CHANNELS_ERROR,
    };
};

export const getDeviceDetailsStore = (state: ApplicationState): DeviceDetailsState => state.deviceDetails;
